import React, { useState, useEffect } from "react";
import "./Payment.css";
import { auth, db } from "../../firebase";
import { collection, addDoc, doc, getDoc } from "firebase/firestore";

const Payment = ({ cart = [], openLoginModal }) => {
  const [address, setAddress] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [mobile, setMobile] = useState("");

  const itemTotal = cart.reduce(
  (total, item) => total + item.price,
  0
);

const visitationFee = cart.length > 0 ? 99 : 0;
const taxesAndFee = 0;

const subtotal = itemTotal + visitationFee + taxesAndFee;


let discount = 0;
let discountLabel = "";


const isFirstUser = cart.length > 0 && itemTotal < 5000; // example condition

if (isFirstUser) {
  discount = itemTotal * 0.10;
  discountLabel = "First User Discount (10%)";
}

if (itemTotal >= 5000) {
  discount = itemTotal * 0.15;
  discountLabel = "Special Discount (15%)";
}

const totalAmount = subtotal - discount;

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;

      if (!user) return;

      try {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();

          setCustomerName(data.name || "");
          setMobile(data.mobile || "");
        }

      } catch (error) {
        console.log("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const handleBooking = async () => {
    const user = auth.currentUser;
    if (!user) {
      openLoginModal(false);
      return;
    }
    if (!cart.length) {
      alert("No services selected");
      return;
    }

    if (!customerName || !mobile || !address) {
      alert("Fill all details");
      return;
    }
    if (!/^[0-9]{10}$/.test(mobile)) {
      alert("Enter valid mobile number");
      return;
    }
    const bookingDate = new Date();
    const warrantyDate = new Date();
    warrantyDate.setMonth(warrantyDate.getMonth() + 6);

    try {
      await addDoc(collection(db, "bookings"), {
        userId: user.uid,
        customerName,
        mobileNumber: mobile,
        address: address,
        servicesBooked: cart.map(item => item.title),
        itemTotal,
        visitationFee,
        taxesAndFee,
        totalAmount,
        bookingDate: bookingDate,
        warrantyDate: warrantyDate
      });
window.gtag('event', 'conversion', {
  'send_to': 'AW-18016363095/xXeCIatBokENfE745D'
});
      alert("Booking Saved Successfully");
      const message = `
New Booking Received:

Customer: ${customerName}
Mobile: ${mobile}
Address: ${address}

Services: ${cart.map(item => item.title).join(", ")}

Total Amount: ₹${totalAmount}
Booking Date: ${bookingDate.toLocaleDateString()}
Warranty Till: ${warrantyDate.toLocaleDateString()}

*Terms & Conditions :* 
1. Warranty does not cover spare parts provided by the customer
2. Booking is confirmed only after successful payment or WhatsApp confirmation.
3. Our team will contact you to confirm service date and time.
4. Same-day service depends on availability.
      `;

      const whatsappURL =
        "https://api.whatsapp.com/send?phone=917661045308&text=" +
        encodeURIComponent(message);

      window.location.href = whatsappURL;

    } catch (error) {
      console.log(error);
      alert("Booking Failed ❌");
    }
  };

  return (
    <div className="container-fluid payment-container">

      <h2 className="payment-title">Book Service Now</h2>

      <div className="payment-wrapper">

        {/* 🔹 LEFT SIDE FORM */}
        <div className="payment-form">

          <input
            type="text"
            placeholder="Customer Name"
            className="form-control mb-3"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
          />

          <input
            type="text"
            placeholder="Mobile Number"
            className="form-control mb-3"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
          <textarea
            placeholder="Service Address"
            className="form-control mb-3"
            rows="3"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <button
            className="btn btn-primary w-100 mt-3"
            onClick={handleBooking}
          >
            Book Now
          </button>

          <div className="container mt-5">
            <dl>
              <dt>
                Terms & Conditions
              </dt>
              <dd className="text-secondary">1. Warranty does not cover spare parts provided by the customer</dd>
              <dd className="text-secondary">2. Booking is confirmed only after successful payment or WhatsApp confirmation.</dd>
              <dd className="text-secondary">3. Our team will contact you to confirm service date and time.</dd>
              <dd className="text-secondary">4. Same-day service depends on availability.</dd>
            </dl>
          </div>
        </div>

        {/* 🔹 RIGHT SIDE CART */}
        <div className="payment-cart">

          <h4>Your Services</h4>

          {cart.length === 0 ? (
            <p>No services selected</p>
          ) : (
            cart.map((item) => (
              <div key={item.id} className="payment-cart-item">
                <span>{item.title}</span>
                <span>₹{item.price}</span>
              </div>
            ))
          )}

          <hr />

          <div className="payment-cart-item">
            <span>Item Total</span>
            <span>₹{itemTotal}</span>
          </div>

          <div className="payment-cart-item ">
            <span className="dashes">Visitation Fee</span>
            <span className="dashes">₹{visitationFee}</span>
          </div>

          <div className="payment-cart-item ">
            <span className="dashes">Taxes & Fee</span>
            <span className="dashes">₹{taxesAndFee}</span>
          </div>
          {discount > 0 && (
  <div className="payment-cart-item text-success">
    <span>{discountLabel}</span>
    <span>- ₹{discount.toFixed(0)}</span>
  </div>
)}
          <hr />

          <div className="mt-2 text-muted" style={{ fontSize: "14px" }}>
            Warranty : 6 Months
          </div>
          <div className="payment-total">
            <span>Total Amount</span>
            <span>₹{totalAmount.toFixed(0)}</span>
          </div>



        </div>

      </div>

    </div>
  );
};

export default Payment;